import React from "react";

export const LazyAccountPage = React.lazy(() => import("./index"));
